import { FinancialActionTypes } from './financials-actions';

export const initialState = {
  orderItemId: undefined,
  clientName: undefined,
  orderName: undefined,
  orderTime: undefined,
  orderAddress: undefined,
  showReceipt: false,
  selectedGateway: undefined,
  gatewaysList: [],
  discountValid: false,
  walletSelected: false,
  discountCode: null,
  creditAmount: 0,
  price: 0,
  totalPrice: 0,
  loading: true,
  discountCodeModal: false,
  discountLoading: false,
  discountAmount: 0,
  paymentLoading: false,
  paymentTrackingCode: undefined,
  paymentStatus: false,
  payWithCredit: false,
  moduleId: undefined,
  moduleIdAffix: undefined,
  orderCompletionAt: undefined,
  orderComment: undefined,
  orderUserFullName: undefined,
  pdfResultId: undefined,
  moduleName: undefined,
  priceUserDeductionAffix: undefined,
  orderReferenceId: undefined,
  cardToCardAffix: false,
  isUploadedReceipt: false,
  cardToCardData: undefined,
  receiptFile: undefined,
  reasonId: undefined,
  cancelOrderLoading: false,
  isShop: false,
  pharmacyDescription: null,
};

function financialReducer(state = initialState, action: any) {
  switch (action.type) {
    case FinancialActionTypes.RESET_ORDER_ITEMS: {
      return {
        ...initialState,
      };
    }

    case FinancialActionTypes.SET_ORDER_ID: {
      return {
        ...state,
        orderItemId: action?.data?.orderItemId,
      };
    }

    case FinancialActionTypes.SET_ORDER_ITEM: {
      return {
        ...state,
        moduleId: action?.data?.orderItemDetails?.module?.value?.toString() || initialState.moduleId,
        moduleIdAffix: action?.data?.orderItemDetails?.module?.title_fa || initialState.moduleIdAffix,
        clientName: action?.data?.orderItemDetails?.detail?.full_name || initialState.clientName,
        orderName: action?.data?.orderItemDetails?.detail?.service_title || initialState.orderName,
        orderUserFullName: action?.data?.orderItemDetails?.detail?.user_full_name || initialState.orderUserFullName,
        orderTime: action?.data?.orderItemDetails?.created_at || initialState.orderTime,
        orderCompletionAt: action?.data?.orderItemDetails?.order_completion_at || initialState.orderCompletionAt,
        orderAddress: action?.data?.orderItemDetails?.detail?.address || initialState.orderAddress,
        orderComment: action?.data?.orderItemDetails?.detail?.comment || initialState.orderComment,
        gatewaysList: action?.data?.orderPaymentDetails?.gateways || initialState.gatewaysList,
        selectedGateway: action?.data?.orderPaymentDetails?.default_gateway || initialState.selectedGateway,
        totalPrice: action?.data?.orderItemDetails?.price || initialState.totalPrice,
        price: action?.data?.orderItemDetails?.price || initialState.price,
        creditAmount: action?.data?.orderItemDetails?.credit_price || initialState.creditAmount,
        paymentTrackingCode: action?.data?.orderItemDetails?.payment?.tracking_code || initialState.paymentTrackingCode,
        paymentStatus: action?.data?.orderItemDetails?.payment?.status === 'succeed',
        payWithCredit: action?.data?.orderItemDetails?.payment?.type === 'CREDIT_PAY',
        moduleName: action?.data?.orderItemDetails?.module?.key,
        priceUserDeductionAffix: action?.data?.orderItemDetails?.price_user_deduction_affix,
        orderReferenceId: action?.data?.orderItemDetails?.order_reference_id_affix || initialState.orderReferenceId,
        cardToCardAffix: action?.data?.orderItemDetails?.card_to_card || initialState.cardToCardAffix,
        cardToCardData: action?.data?.cardToCardData || initialState.cardToCardData,
        loading: false,
      };
    }

    case FinancialActionTypes.SET_SELECTED_GATEWAY: {
      return {
        ...state,
        selectedGateway: action?.data?.selectedGateway,
      };
    }

    case FinancialActionTypes.GET_ORDER_ITEM: {
      return {
        ...state,
        orderItemId: action?.data?.orderItemId,
      };
    }

    case FinancialActionTypes.SET_ORDER_LOADING: {
      return {
        ...state,
        paymentLoading: action?.data?.paymentLoading,
      };
    }

    case FinancialActionTypes.SET_SELECTED_WALLET: {
      let totalPrice = state.price;
      if (action?.data?.walletSelected) {
        if (state.price <= state.creditAmount) {
          totalPrice = 0;
        } else {
          totalPrice = state.price - state.creditAmount;
        }
      }
      return {
        ...state,
        walletSelected: action?.data?.walletSelected,
        totalPrice: totalPrice,
      };
    }

    case FinancialActionTypes.SET_DISCOUNT_MODAL: {
      return {
        ...state,
        discountCodeModal: action?.data?.discountCodeModal,
      };
    }

    case FinancialActionTypes.SET_DISCOUNT_CODE: {
      return {
        ...state,
        discountCode: action?.data?.discountCode,
      };
    }

    case FinancialActionTypes.GET_CODE_VALIDATION: {
      return {
        ...state,
        discountLoading: true,
      };
    }

    case FinancialActionTypes.SET_DISCOUNT_VALIDATION: {
      return {
        ...state,
        discountAmount: action?.data?.discountAmount,
        discountValid: action?.data?.discountValid,
        discountLoading: false,
        discountCodeModal: false,
        discountCode: action?.data?.discountCode,
      };
    }

    case FinancialActionTypes.SET_ORDER_PAYMENT: {
      return {
        ...state,
        paymentLoading: true,
      };
    }

    case FinancialActionTypes.DELETE_DISCOUNT_CODE: {
      return {
        ...state,
        discountCode: initialState.discountCode,
        discountValid: initialState.discountValid,
        discountLoading: initialState.discountLoading,
        discountAmount: initialState.discountAmount,
      };
    }

    case FinancialActionTypes.SET_RECEIPT_FILE:
      return {
        ...state,
        receiptFile: action?.data?.receiptFile,
      };

    case FinancialActionTypes.SEND_CARD_TO_CARD_RECEIPT_ORDER: {
      return {
        ...state,
        paymentLoading: true,
      };
    }

    case FinancialActionTypes.SET_IS_UPLOADED_RECEIPT: {
      return {
        ...state,
        isUploadedReceipt: true,
      };
    }

    case FinancialActionTypes.HANDLE_CANCEL_ORDER:
      return {
        ...state,
        reasonId: action?.data?.reasonId,
        cancelOrderLoading: true,
      };

    case FinancialActionTypes.SET_CANCEL_ORDER_LOADING: {
      return {
        ...state,
        cancelOrderLoading: action?.data?.cancelOrderLoading,
      };
    }

    case FinancialActionTypes.SET_IS_SHOP:
      return {
        ...state,
        isShop: true,
      };

    case FinancialActionTypes.SET_PHARMACY_DESCRIPTION:
      return {
        ...state,
        pharmacyDescription: action?.data?.description,
      };

    default:
      return state;
  }
}

export default financialReducer;
